import { NavLink } from '@dtx-company/true-common/src/types/appContent'

export const getNavLinkDataTestType = (item: NavLink): string => {
  if (item.link && item.isExternal) {
    return 'external'
  } else if (item.link) {
    return 'internal'
  } else {
    return 'text'
  }
}
